import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../shared/shared.module';
import { AccountComponent } from './components/account/account.component';
import { AccountRoutingModule } from './account-routing.module';
import { ReactiveFormModule } from '@mobilefirstdev/reactive-form';
import { ReactiveButtonsModule } from '@mobilefirstdev/reactive-buttons';
import { RxPush } from '@rx-angular/template/push';
import { ChangePasswordComponent } from './components/modals/change-password/change-password.component';
import { ToastModule } from '../../modules/toasts/toast.module';

@NgModule({
  declarations: [AccountComponent, ChangePasswordComponent],
  imports: [
    CommonModule,
    ToastModule,
    ReactiveFormModule,
    SharedModule,
    AccountRoutingModule,
    ReactiveButtonsModule,
    RxPush
  ]
})
export class AccountModule {}
